import React from "react";
import HomeIndex from "../../components/new_design/HomeIndex";

function NewDesignHome() {
    return <HomeIndex />;
}

export default NewDesignHome;
